import { createStore } from "vuex";
import InviteService from "../services/InviteService";
import AccountService from "../services/AccountService";
import { auth, useE2EAuth } from "./auth";
import { onAuthStateChanged } from "firebase/auth";
import FirebaseService from "../services/FirebaseService";
import { accountCreationAllowed } from "../config/accountCreation";

export default createStore({
  state: {
    user: null
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      (state.user = userData), localStorage.setItem("user", JSON.stringify(userData));
    },
    CLEAR_USER_DATA() {
      localStorage.removeItem("user");
      location.reload();
    }
  },
  actions: {
    login({ commit }, credentials) {
      return FirebaseService.authenticate(credentials.email, credentials.password).then(user => {
        commit("SET_USER_DATA", user);
      });
    },
    async signup({ commit }, details) {
      if (!accountCreationAllowed) {
        return Promise.reject(new Error("Account creation is currently closed for private beta."));
      }

      if (!details.inviteToken) {
        throw new Error("Open a valid invite link to create an account.");
      }
      // Check before creating a Firebase identity, then recheck on the server
      // when atomically creating the Movie List account and membership.
      await InviteService.getPreview(details.inviteToken);
      const currentUser = auth.currentUser;
      const user =
        currentUser && currentUser.email && currentUser.email.toLowerCase() === details.email.trim().toLowerCase()
          ? currentUser
          : await FirebaseService.register(details.email, details.password, details.displayName);
      commit("SET_USER_DATA", user);
      return InviteService.join(details.inviteToken);
    },
    logout({ commit }) {
      commit("CLEAR_USER_DATA");
      return auth.signOut();
    },
    saveDeatils({ commit }, details) {
      return AccountService.saveDetails(details.displayName, details.email).then(data => {
        commit("SET_USER_DATA", data);
      });
    },
    checkAuth({ commit }) {
      if (useE2EAuth) {
        const savedUser = JSON.parse(localStorage.getItem("user") || "null");

        if (savedUser) {
          savedUser.getIdToken = () => Promise.resolve(`e2e:${savedUser.email}`);
          auth.currentUser = savedUser;
        }

        commit("SET_USER_DATA", savedUser);
        return Promise.resolve(savedUser);
      }

      return new Promise(resolve => {
        onAuthStateChanged(auth, user => {
          if (user) {
            commit("SET_USER_DATA", user);
          } else {
            commit("SET_USER_DATA", null);
          }
          resolve(user);
        });
      });
    }
  },
  modules: {},
  getters: {
    loggedIn(state) {
      return !!state.user;
    },
    userId(state) {
      if (state.user == null) {
        return null;
      } else {
        return state.user.uid;
      }
    },
    email(state) {
      if (state.user == null) {
        return null;
      } else {
        return state.user.email;
      }
    },
    emailVerified(state) {
      if (state.user == null) {
        return null;
      } else {
        console.log(state.user);
        return state.user.emailVerified;
      }
    },
    displayName(state) {
      if (state.user == null) {
        return null;
      } else {
        return state.user.displayName;
      }
    }
  }
});
